(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Benefit-Slider"] && !Shopify.designMode) return;
  try {
    
let swiperItems = document.querySelectorAll('.swiper-slide');
console.log('Slider läuft');
  
    var swiper = new Swiper(".mySwiper", {
        loop: true,  
        slidesPerView: 1,
        autoplay: {
          delay: 3000,
        }
    });

  swiper.init();
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product_price_comparison_lbrgt"] && !Shopify.designMode) return;
  try {
    
(function() {
  const section = document.getElementById('comparisonSection');
  if (!section) return;

  const observer = new IntersectionObserver(function(entries) {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('in-view');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.3, rootMargin: '0px' });

  observer.observe(section);
})();

  } catch(e) { console.error(e); }
})();
})();
